import React, { Component } from 'react';
import API from './API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from 'react-awesome-modal';
import DateHelper from './DateHelper'

class PageMenu extends Component {
    constructor(){
      super();
      this.state = {
        showCreateWifiUserModal: false,
        newUserDuration: undefined,
        newUser: undefined
      }
    }

    componentDidMount(){
        
    }

    onClick_openNewWifiUserModal(){
        this.setState({
            newUser: undefined,
            newUserDuration: 'hour1',
            showCreateWifiUserModal: true
        });
    }

    closeModal(){
        this.setState({showCreateWifiUserModal: false});
    }

    onChange_duration(durationValue){
        this.setState({
            newUserDuration: durationValue
        });
    }

    onClick_ok(){
        var me = this;
        var data = {
            newUserDuration: me.state.newUserDuration
        }
        API.callAPI('App.createWifiUser', data, function(resp){
            me.setState({
                newUser: resp.data.newUser
            });
        }, function(b){
            me.forceUpdate();
        });
    }

    render(){
        var me = this;
        return (
            <div className="page menu">
                <div className="buttonHolder">
                    <div
                        onClick={me.onClick_openNewWifiUserModal.bind(me)}
                        className="btn btn-primary button">

                        <div className="icon">
                            <FontAwesomeIcon icon="plus" size="3x" />                        
                        </div>

                        <div>Új Wifi-azonosító kiadása</div>
                    </div>
                </div>


                <Modal 
                    visible={this.state.showCreateWifiUserModal}
                    width="90%"
                    height="90%"
                    effect="fadeInUp"
                    onClickAway={() => this.closeModal()}
                >
                    {(me.state.newUser === undefined) ? 
                        <div className="modalNewWifiUserSettings">
                            <h2>Új wifi-azonosító létrehozása</h2>

                            <div className={"durOption btn btn-" + ((me.state.newUserDuration === 'hour1') ? 'primary' : 'default')}
                                onClick={me.onChange_duration.bind(me, 'hour1')}>
                                Egy órára
                            </div>

                            &nbsp;&nbsp;&nbsp;&nbsp;

                            <div className={"durOption btn btn-" + ((me.state.newUserDuration === 'day1') ? 'primary' : 'default')}
                                onClick={me.onChange_duration.bind(me, 'day1')}>
                                Egész napra
                            </div>

                            <br /><br /><br />

                            <div className="btnOk btn btn-primary" onClick={me.onClick_ok.bind(me)}>Mehet</div>
                            <div className="btnMegse btn btn-default" onClick={() => this.closeModal()}>Mégse</div>
                        </div>
                    :
                        <div className="modalNewWifiUserAnswer">
                            <div className="title">Az új azonosító</div>
                            <div className="value">{me.state.newUser.Wifiusername}</div>

                            <div className="title">Jelszava</div>
                            <div className="value">{me.state.newUser.Password}</div>

                            <div className="title">Érvényesség vége</div>
                            <div className="value">{DateHelper.getHunDate(me.state.newUser.Validuntil) + " " + DateHelper.getHunTime(me.state.newUser.Validuntil)}</div>
                        </div>
                    }
                </Modal>                
            </div>
        )
    }
}

export default PageMenu;
